import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useClickOutOfElement } from "../../custom-hooks/base-hooks/useClickOutOfElement";
import CheckMarkIconSVG from "../resources/svg/CheckMarkIconSVG";
import DropdownArrowSVG from "../resources/svg/functional/DropdownArrowSVG";
import CurrencyIconSVG from "../resources/svg/CurrencyIconSVG";
import currencyServiceFactory from "../../services/CurrencyServiceImpl";
import { Currency } from "../../domain/enums/CurrencyEnum";
import { CurrencyServiceImpl } from "../../services/CurrencyServiceImpl";

const currencyService = currencyServiceFactory();

const FooterCurrencyChange: FC = () => {
    const { t } = useTranslation();
    const tooltipRef = useRef(null);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const [currency, setCurrency] = useState(currencyService.currentCurrency);
    useEffect(() => {
        const subscription = CurrencyServiceImpl.currency$.subscribe(setCurrency);
        return () => subscription.unsubscribe();
    }, []);
    useClickOutOfElement(tooltipRef, () => setIsTooltipVisible(false));
    const handleChangeCurrency = (currency: Currency) => {
        setIsTooltipVisible(false);
        currencyService.setCurrentCurrency(currency);
    };

    return (
        <div ref={tooltipRef} className="relative flex justify-center items-center group">
            <CurrencyIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textFaded group-hover:text-textWhite transition-all duration-300" />
            <div
                onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                className=" flex justify-center items-center cursor-pointer"
            >
                <span className="H20 td4:H16 tmax4:H14 text-textFaded group-hover:text-textWhite ml-3 transition-all duration-300">
                    {t("common.currencyOfWebsite")}
                </span>
                <span className="H20B td4:H16B tmax4:H14B text-textWhite ml-2 mr-2">
                    {t(`currencies.short.${currency}`)}
                </span>
                <DropdownArrowSVG className="tmax4:w-4 tmax4:h-[8px] text-textFaded group-hover:text-textWhite transition-all duration-300" />
            </div>
            <div
                className={`absolute top-10 right-0 z-10 bg-backgroundInput w-[160px] h-[144px] py-4 px-6 rounded-[7px] transition-all duration-300 ${
                    isTooltipVisible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
                }`}
            >
                {currencyService.currencies.map((currency, index, arr) => (
                    <p
                        className={`relative H20 text-textWhite text-center w-[112px] h-[32px] ${
                            index === arr.length - 1 ? "mt-[12px]" : "border-b border-textFaded"
                        } ${
                            index !== 0 ? "mt-[12px]" : ""
                        } hover:font-[500] cursor-pointer transition-all duration-300`}
                        onClick={() => handleChangeCurrency(currency)}
                        key={`p-currency-selection-${currency}`}
                    >
                        {t(`currencies.short.${currency}`)}
                        {currencyService.isCurrentCurrency(currency) && (
                            <CheckMarkIconSVG className="absolute top-[5px] right-[15px]" />
                        )}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default FooterCurrencyChange;
